import type { QueryClient } from "@tanstack/react-query"
import type { CachedAuthResult } from "../api/client"
import { currentIdentity } from "./identity"

/**
 * Сохраняет результат авторизации (login/register) в query-кэш
 * под правильным ключом для текущей платформы.
 *
 * Без этого `resolveUser` → `queryClient.query` возвращает
 * устаревшие данные (например `{ exists: false }` до регистрации).
 */
export function cacheAuthResult(
	queryClient: QueryClient,
	result: CachedAuthResult,
): Promise<void> {
	return currentIdentity().cache(queryClient, result)
}
